import { apiInitCybersource } from '../requests'
import {
  updateCybersourceCheckout,
  apiInitCybersourceStart,
  apiInitCybersourceSuccess,
  apiInitCybersourceFail,
} from './actions'

export const operationProcessCybersourceCheckoutResponse = (response) => (dispatch) => {
  const {
    pageAttributes: { ...authData },
  } = response
  dispatch(updateCybersourceCheckout({ authData }))
}

export const operationApiInitCybersource = () => async (dispatch) => {
  dispatch(apiInitCybersourceStart())

  try {
    const response = await apiInitCybersource()
    dispatch(apiInitCybersourceSuccess({ response }))
  } catch (error) {
    dispatch(apiInitCybersourceFail())
  }
}
